<button class="flex h-full w-full items-center" [ngClass]="buttonClass()" (click)="toggleReleaseNotes()">
  <div class="relative">
    <i class="pi pi-file-check mr-4 !text-lg text-zinc-800"></i>
    <app-red-dot [visible]="updatesAvailable()" styleClass="left-4 top-0" />
  </div>
  {{ 'releaseNotes.triggerLink' | transloco }}
</button>
